(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["skin-diagnostic-quiz"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sdqInitialized) return;
    window.__sdqInitialized = true;

    // Etat par instance de bloc (plusieurs quiz possibles sur une meme page).
    var answersByRoot = new WeakMap();

    function getAnswers(root) {
      if (!answersByRoot.has(root)) answersByRoot.set(root, {});
      return answersByRoot.get(root);
    }

    function getModal(root) {
      return root.__sdqModal || root.querySelector("[data-sdq-modal]");
    }

    function getScope(root) {
      return getModal(root) || root;
    }

    function showStep(root, name) {
      var scope = getScope(root);
      scope.querySelectorAll("[data-sdq-step]").forEach(function (step) {
        step.hidden = step.getAttribute("data-sdq-step") !== name;
      });
      var progressFill = scope.querySelector("[data-sdq-progress-fill]");
      if (progressFill) {
        var pct = { "1": 25, "2": 50, "3": 75, "results": 100 }[name] || 25;
        progressFill.style.width = pct + "%";
      }
    }

    function openModal(root) {
      var modal = getModal(root);
      if (!modal) return;

      // Le bloc peut etre place dans un slider ou un conteneur avec transform /
      // overflow hidden : un element position:fixed y serait rogne et invisible.
      // On le rattache donc au <body> avant de l'ouvrir.
      if (modal.parentElement !== document.body) {
        root.__sdqModal = modal;
        modal.__sdqRoot = root;
        document.body.appendChild(modal);
      }

      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add("is-open");
      });
      document.body.style.overflow = "hidden";
    }

    function closeModal(root) {
      var modal = getModal(root);
      if (!modal) return;
      modal.classList.remove("is-open");
      document.body.style.overflow = "";
      setTimeout(function () {
        modal.hidden = true;
      }, 150);
    }

    function appendRole(root, container, role, concern) {
      var dataRoot = root.querySelector("[data-sdq-data]");
      if (!dataRoot) return;
      var selector = concern
        ? '[data-role="' + role + '"][data-concern="' + concern + '"]'
        : '[data-role="' + role + '"]';
      var source = dataRoot.querySelector(selector);
      if (source && source.innerHTML.trim() !== "") {
        var wrap = document.createElement("div");
        wrap.innerHTML = source.innerHTML;
        container.appendChild(wrap.firstElementChild);
      }
    }

    function showResults(root) {
      var scope = getScope(root);
      var answers = getAnswers(root);
      var routine = scope.querySelector("[data-sdq-routine]");
      var title = scope.querySelector("[data-sdq-results-title]");
      if (!routine) return;
      routine.innerHTML = "";

      if (title && answers.skin_type) {
        title.textContent = "Ta routine pour peau " + answers.skin_type;
      }

      appendRole(root, routine, "cleanser", null);
      appendRole(root, routine, "peeling", answers.concern1);
      if (answers.concern2) appendRole(root, routine, "peeling", answers.concern2);
      appendRole(root, routine, "actif", answers.concern1);
      if (answers.concern2) appendRole(root, routine, "actif", answers.concern2);
      appendRole(root, routine, "serum", answers.concern1);
      if (answers.concern2) appendRole(root, routine, "serum", answers.concern2);
      appendRole(root, routine, "cream", answers.concern1);
      if (answers.concern2) appendRole(root, routine, "cream", answers.concern2);
      appendRole(root, routine, "accessoire", answers.concern1);
      if (answers.concern2) appendRole(root, routine, "accessoire", answers.concern2);

      showStep(root, "results");
    }

    function resolveRoot(target) {
      var root = target.closest("[data-sdq]");
      if (root) return root;
      var modal = target.closest("[data-sdq-modal]");
      return modal && modal.__sdqRoot ? modal.__sdqRoot : null;
    }

    // Delegation au niveau du document : le quiz continue de fonctionner meme si
    // le bloc est ajoute, deplace ou re-rendu apres le chargement du script.
    document.addEventListener("click", function (event) {
      if (!event.target || !event.target.closest) return;
      var target = event.target.closest("button");
      if (!target) return;
      var root = resolveRoot(target);
      if (!root) return;

      if (target.hasAttribute("data-sdq-open")) {
        event.preventDefault();
        answersByRoot.set(root, {});
        openModal(root);
        showStep(root, "1");
        return;
      }

      if (target.hasAttribute("data-sdq-close")) {
        event.preventDefault();
        closeModal(root);
        return;
      }

      if (target.hasAttribute("data-sdq-back")) {
        event.preventDefault();
        showStep(root, target.getAttribute("data-sdq-back"));
        return;
      }

      if (target.hasAttribute("data-sdq-restart")) {
        event.preventDefault();
        answersByRoot.set(root, {});
        showStep(root, "1");
        return;
      }

      var answerType = target.getAttribute("data-sdq-answer");
      if (!answerType) return;
      var answers = getAnswers(root);

      if (answerType === "skin_type") {
        event.preventDefault();
        answers.skin_type = target.getAttribute("data-sdq-value");
        showStep(root, "2");
        return;
      }

      if (answerType === "concern1") {
        event.preventDefault();
        answers.concern1 = target.getAttribute("data-sdq-value");
        showStep(root, "3");
        return;
      }

      if (answerType === "concern2") {
        event.preventDefault();
        var val = target.getAttribute("data-sdq-value");
        answers.concern2 = val === answers.concern1 ? "" : val;
        showResults(root);
        return;
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      document.querySelectorAll("[data-sdq-modal]").forEach(function (modal) {
        if (modal.hidden) return;
        var root = modal.__sdqRoot || modal.closest("[data-sdq]");
        if (root) closeModal(root);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
